"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileEditPhoneUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var lifecycle_events_1 = require("../../../lifecycle-events");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var components_2 = require("./components");
var ProfileEditPhoneUI = function (_a) {
    var _b;
    var profile = _a.profile, mutate = _a.mutate, mutationLoading = _a.mutationLoading;
    var _c = (0, core_1.useComponents)(), Heading1 = _c.Heading1, Card = _c.Card, Stack = _c.Stack, ErrorSummaryNotification = _c.ErrorSummaryNotification, ErrorNotification = _c.ErrorNotification;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    var checkPhoneNumber = copy('profile.checkPhoneNumber');
    var _e = __read((0, react_1.useState)([]), 2), errors = _e[0], setErrors = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), apiError = _f[0], setApiError = _f[1];
    var errorCodesMap = (0, react_1.useMemo)(function () { return ({
        PHONE_INVALID: checkPhoneNumber,
    }); }, [checkPhoneNumber]);
    var errorMessages = (0, react_1.useMemo)(function () { return (0, utils_1.getErrorMessages)(errors, errorCodesMap); }, [
        errors,
        errorCodesMap,
    ]);
    var _g = __read((0, react_1.useState)(profile.phoneNumbers), 2), phoneNumbers = _g[0], setPhoneNumbers = _g[1];
    var dispatch = (0, ui_tools_1.useEvents)().dispatch;
    var navigate = (0, ui_tools_1.useNavigate)();
    var profileLink = (0, core_1.useLinks)().profile;
    var handleRouteProfile = (0, react_1.useCallback)(function () {
        navigate(profileLink());
    }, [navigate, profileLink]);
    var handleSubmit = function (event) {
        event.preventDefault();
        if (mutationLoading) {
            return;
        }
        setApiError(false);
        var validationErrors = (0, utils_1.getPhoneValidationErrors)(phoneNumbers);
        if (validationErrors.length) {
            setErrors(validationErrors);
            return;
        }
        var body = (0, utils_1.getPhoneSubmitBody)(profile, phoneNumbers.map(utils_1.normalisePhoneNumber));
        if (Object.keys(body).length === 0) {
            screen_reader_route_manager_1.default.beforeRouteChange();
            handleRouteProfile();
            return;
        }
        mutate(body, {
            onError: function () {
                setApiError(true);
            },
            onCompleted: function () {
                dispatch(lifecycle_events_1.PROFILE_UPDATE_SUCCESS);
                screen_reader_route_manager_1.default.beforeRouteChange();
                handleRouteProfile();
            },
        });
    };
    var handlePhoneChange = function (_a) {
        var _b = _a.currentTarget, index = _b.dataset.index, value = _b.value;
        var indexNumber = Number(index);
        var allPhoneNumbers = __spreadArray(__spreadArray(__spreadArray([], __read(phoneNumbers.slice(0, indexNumber)), false), [
            value
        ], false), __read(phoneNumbers.slice(indexNumber + 1)), false);
        setPhoneNumbers(allPhoneNumbers);
    };
    return (react_1.default.createElement(Card, { "data-testid": section_ids_1.PROFILE_EDIT_PHONE_SECTION_ID },
        apiError ? (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.PROFILE_UPDATE_ERROR_NOTIFICATION, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(ErrorNotification, { id: section_ids_1.PROFILE_UPDATE_ERROR, "data-testid": section_ids_1.PROFILE_UPDATE_ERROR },
                react_1.default.createElement(Copy, { copyKey: "profile.updateError" })))) : null,
        react_1.default.createElement(ErrorSummaryNotification, { id: "profile-error-summary", errors: errorMessages }),
        react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.PROFILE_PHONE_EDIT_CANCEL_BREADCRUMB, properties: { INTERNAL_EVENT_FLAG: true } },
                react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: profileLink() }, copy('profile.backtoProfile'))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading1, null, copy('profile.editAccountPhoneHeading')),
                react_1.default.createElement("form", { onSubmit: handleSubmit, noValidate: true },
                    react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                        react_1.default.createElement(components_2.PhoneNumbersField, { value: phoneNumbers, errors: errorMessages, handler: handlePhoneChange }),
                        react_1.default.createElement(components_2.Controls, { loading: mutationLoading })))))));
};
exports.ProfileEditPhoneUI = ProfileEditPhoneUI;
